import application from 'application/application';

import template from './add-automatic-processes.template.html';

import controller from './add-automatic-processes.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.addAutomaticProcesses', {
				url: '/cadastrar-processos-automaticos?n&NumeroProcesso&situacao',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Cadastrar processos automaticos'
				}
			});

	}]);
